import React, {useContext} from "react";
import {Divider, FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {WebSettingsContext} from "../../../../../context/WebSettingsContext";
import {UI, rgba} from "../../uiTokens";
import {fieldSx} from "../editMenuStyles";
import {SectionHeader} from "../components/EditMenuSection";
import {MessageListEditor} from "../components/MessageListEditor";

export const GreetMessageTab = ({node, setNode, onUpdate, project, flow}) => {
    const {settings} = useContext(WebSettingsContext);

    const onChangeMessage = async (index, value) => {
        const state = {...node};
        if (state.data.greet[index] !== value) {
            state.data.greet[index] = value;
            setNode(state);
        }
    };
    const onUpdateMessage = async () => {
        await onUpdate(node);
    };

    const removeGreetMessage = async (index) => {
        const state = {...node};
        state.data.greet = state.data.greet?.filter((greet, ind) => ind !== index);
        await onUpdate(state);
    };

    const addGreetMessage = async () => {
        const state = {...node};
        if (state?.data?.greet?.length === 0) {
            state.data.greet = [];
        }
        state.data.greet = [...state.data.greet, ""];
        await onUpdate(state);
    };

    const {primary, secondary} = menuItemsInfo.greet;
    const variables = project?.flow_variables?.[flow?.id] || [];

    const audios = settings?.audios || [];
    const selectedAudio = audios?.find(i => i?.path === node?.data?.please_wait_message)?.path || null;
    const greetMessages = node?.data?.greet || [];

    return (
        <>
            <SectionHeader title={primary} description={secondary}/>

            <MessageListEditor
                messages={greetMessages}
                variables={variables}
                onChange={onChangeMessage}
                onCommit={() => onUpdateMessage()}
                onRemove={removeGreetMessage}
                onAdd={addGreetMessage}
                addLabel="Add message"
                emptyLabel="No greet messages yet."
            />

            <SectionHeader
                title="Please wait message"
                description="Message the agent can send while waiting for a response"
            />
            <TextField
                value={selectedAudio ? "" : node?.data?.please_wait_message || ""}
                size="small"
                sx={fieldSx}
                placeholder="Write here wait message..."
                multiline
                minRows={3}
                maxRows={5}
                onChange={e => setNode(prev => ({
                    ...prev,
                    data: {...(prev?.data || {}), please_wait_message: e.target.value},
                }))}
                onBlur={() => onUpdateMessage()}
            />

            <Divider
                sx={{
                    color: UI.muted,
                    fontSize: 10.5,
                    fontWeight: 700,
                    letterSpacing: "0.08em",
                    "&::before, &::after": {borderColor: rgba(UI.ink, 0.1)},
                }}
            >
                OR
            </Divider>

            <FormControl size="small" sx={fieldSx}>
                <InputLabel id="audio-label">Audio</InputLabel>
                <Select
                    labelId="audio-label"
                    id="audio-select"
                    value={selectedAudio || "none"}
                    label="Audio"
                    onChange={e => setNode(prev => ({
                        ...prev,
                        data: {...(prev?.data || {}), please_wait_message: e.target.value},
                    }))}
                    onBlur={() => onUpdateMessage()}
                    MenuProps={{
                        slotProps: {
                            paper: {
                                sx: {
                                    borderRadius: "10px",
                                    border: `1px solid ${rgba(UI.accent, 0.16)}`,
                                    boxShadow: UI.shadow,
                                },
                            },
                        },
                    }}
                >
                    <MenuItem value="none"><em>{selectedAudio ? "None" : "--Select Audio--"}</em></MenuItem>
                    {audios?.map(audio => (
                        <MenuItem key={audio?.path} value={audio?.path}>{audio?.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
};
